import {
  Divider,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FieldArray, useFormikContext } from 'formik';
import parse from 'html-react-parser';
import React, { Fragment } from 'react';
import { MdHighlightOff } from 'react-icons/md';
import { mailStyles } from './styles';

const MailForm = ({ templateMail }) => {
  const { values, errors, touched, submitCount, handleChange, handleBlur } = useFormikContext();

  const styles = mailStyles();

  const _errors = {
    assunto: (submitCount > 0 || touched?.assunto) && errors?.assunto,
  };

  return (
    <Grid container spacing={3} className="mt-16">
      <FieldArray
        name="emails"
        render={(arrayHelpers) => {
          return (
            <>
              {values?.emails?.map((email, i) => {
                const _errorMail =
                  (submitCount > 0 || (touched?.emails?.length > 0 && touched?.emails[i])) &&
                  errors?.emails?.length > 0 &&
                  errors?.emails[i];

                return (
                  <Fragment key={email?.key}>
                    <Grid item xs={12}>
                      <TextField
                        autoFocus={i === 0}
                        fullWidth
                        id={`emails[${i}]`}
                        label="E-mail do destinatário"
                        required
                        type="email"
                        variant="outlined"
                        value={email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={_errorMail}
                        helperText={_errorMail}
                        touched={!!_errorMail}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {i > 0 && (
                                <Tooltip title="Remover" placement="right-end">
                                  <IconButton
                                    onClick={() => {
                                      arrayHelpers.remove(i);
                                    }}
                                  >
                                    <MdHighlightOff size={22} />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </InputAdornment>
                          ),
                        }}
                        inputProps={{ maxLength: 200 }}
                      />
                    </Grid>
                  </Fragment>
                );
              })}
              {values?.emails?.length < 5 && (
                <Grid item xs={12}>
                  <button
                    className={styles.buttonAdicionarEmail}
                    type="button"
                    href=""
                    onClick={() => {
                      arrayHelpers.push('');
                    }}
                  >
                    Adicionar e-mail
                  </button>
                </Grid>
              )}
            </>
          );
        }}
      />

      <Grid item xs={12}>
        <TextField
          id="assunto"
          name="assunto"
          label="Assunto"
          required
          variant="outlined"
          fullWidth
          value={values?.assunto}
          onChange={handleChange}
          onBlur={handleBlur}
          error={_errors.assunto}
          helperText={_errors.assunto}
          touched={!!_errors.assunto}
          inputProps={{ maxLength: 100 }}
        />
      </Grid>

      <Grid item xs={12}>
        <ExpansionPanel style={{ maxWidth: 589 }}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography style={{ marginRight: 16, fontWeight: 700, textTransform: 'initial' }} variant="button">
              Detalhes do e-mail
            </Typography>
          </ExpansionPanelSummary>
          <Divider />
          <ExpansionPanelDetails>{parse(`${templateMail}`)}</ExpansionPanelDetails>
        </ExpansionPanel>
      </Grid>
    </Grid>
  );
};

export default MailForm;
